'use client'

import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

import BidRowsSkeleton from './BidRowsSkeleton'
import { Card, CtaStack, Outer, PanelArea, SkeletonBlock } from './ui'

const TitleSkeleton = styled(SkeletonBlock)`
  width: 60%;
  height: 1.5rem;
`

const TabsSkeleton = styled(SkeletonBlock)`
  width: 100%;
  height: 2.5rem;
`

const CtaSkeleton = styled(SkeletonBlock)`
  width: 100%;
  height: 2.5rem;
`

export default function OrdersBidsDashboardSkeleton() {
  const intl = useIntl()

  return (
    <Outer>
      <Card
        aria-busy="true"
        aria-label={intl.formatMessage({
          id: 'Search.ordersBidsDashboard.loading',
        })}
        data-testid="orders-bids-dashboard-skeleton"
      >
        <TitleSkeleton />
        <TabsSkeleton />
        <PanelArea>
          <BidRowsSkeleton />
        </PanelArea>
        <CtaStack>
          <CtaSkeleton />
        </CtaStack>
      </Card>
    </Outer>
  )
}
